import moodImg from "../../assets/quiz/mood.png";
import intensityImg from "../../assets/quiz/intensity.png"; // intensity
import tasteImg from "../../assets/quiz/taste.png"; // taste
import bitternessImg from "../../assets/quiz/bitterness.png"; // bitterness
import experimentalImg from "../../assets/quiz/intensity.png"; // experimental

const QUESTION_IMAGES = {
  mood: moodImg,
  intensity: intensityImg,
  taste: tasteImg,
  bitterness: bitternessImg,
  experimental: experimentalImg,
};

export default function BeerFinderQuestionScreen({
  t,
  step,
  total,
  question,
  onAnswer,
  onBack,
}) {
  const image = QUESTION_IMAGES[question.id];

  return (
    <div className="beerFinder">
      <div key={step} className="beerFinderQuestionCard">
        <div className="beerFinderProgress">
          <span>
            {t("question")} {step + 1} {t("of")} {total}
          </span>

          <div className="beerFinderProgressBar">
            <div
              style={{
                width: `${((step + 1) / total) * 100}%`,
              }}
            />
          </div>
        </div>

        {image ? (
          <div className="beerFinderQuestionImageWrap">
            <img src={image} alt={t(question.titleKey)} />
          </div>
        ) : null}

        <h2 className="beerFinderQuestionTitle">{t(question.titleKey)}</h2>

        <div className="beerFinderOptions">
          {question.options.map((option, index) => (
            <button
              key={option.value}
              className="beerFinderOption"
              type="button"
              style={{ animationDelay: `${index * 0.12}s` }}
              onClick={() => onAnswer(question.id, option.value)}
            >
              {t(option.labelKey)}
            </button>
          ))}
        </div>

        {step > 0 ? (
          <button
            className="beerFinderBackBtn"
            type="button"
            onClick={onBack}
          >
            {t("back")}
          </button>
        ) : null}
      </div>
    </div>
  );
}